/*
 * Title : GentleUtil Object 
 * Author : KimTaeOh 
 * Email : taeoh.kim@gentlepie.com
 * Description: 유틸리티 모음입니다 다른 객체와는 다르게 인스턴스화한 객체별로 상태를 처리하지 않고 파라미터를 받아서 원하는 결과를 처리합니다 
 * Property Value
 * @slidePopupID : 슬라이드팝업의 고유번호   
 * @slidePopupOverlayID : 슬라이드팝업 오버레이 영역의 고유번호 
 * @serviceLodingID : 서비스로딩바 고유번호 
 * @toastMessageID : 토스트팝업의 고유번호 
 * @toastMessageRemoveTimer : 토스트팝업 setTimeout을 담을 프로퍼티 
 * @toastMessageRemoveTime : 토스트팝업 유지시간 (ms)
 */ 

import GentleAppState from '../common/appstate';
import GentleConst from '../common/const';
import GentleComponentTimeStamp from '../component/timeStamp';
import GentleLang from './lang';
import GentleComponentBubble from '../component/bubble';
import GentleProxy from '../common/proxy';

var GentleUtil = Object.create(null,{
    divisionCount:  { writable: true, configurable: true, enumerable: true, value: 0},
    $chatConsoleBottomSelector:  { writable: true, configurable: true, enumerable: true, value: $('#chatConsoleBottomSpacing')},
    slidePopupID: { writable: false, configurable: false, enumerable: false, value:'slide-popup'},
    slidePopupContentID: { writable: false, configurable: false, enumerable: false, value:'slide-popup-content'},
    slidePopupOverlayID: { writable: false, configurable: false, enumerable: false, value:'slide-popup-overlay'},
    toastMessageID: { writable: false, configurable: false, enumerable: false, value:'toast-update-message'},
    toastUpdateMessageID: { writable: false, configurable: false, enumerable: false, value:'toast-message'},
    quickMenuOverlayID: { writable: false, configurable: false, enumerable: false, value:'quick-menu-overlay'},
    serviceLodingID: { writable: false, configurable: false, enumerable: false, value:'service-loading'},
    $quickMenuButtonSelector: { writable: false, configurable: false, enumerable: false, value:$("#quick-menu-button")},
    $quickMenuSelector: { writable: false, configurable: false, enumerable: false, value:$("#gentle-quick-menu")},
    toastMessageRemoveTimer: { writable: true, configurable: false, enumerable: false},
    toastMessageRemoveTime: { writable: true, configurable: false, enumerable: false, value:1000},
    toastUpdateMessageRemoveTime: { writable: true, configurable: false, enumerable: false, value:10000},
    chatConsoleRenderState: { writable: true, configurable: false, enumerable: false, value: false }
});

GentleUtil.notSupported = function(){
    const html = GentleLang.translate(GentleLang.type.NotSupported);
    var bubble = Object.create( GentleComponentBubble );   
    bubble.createComponent({
            html,
    });
    return bubble
}

GentleUtil.sorry = function(){
    const html = GentleLang.translate(GentleLang.type.Sorry);
    var bubble = Object.create( GentleComponentBubble );   
    bubble.createComponent({
            html,
    });
    return bubble
}

// 퀵메뉴 초기화 
// 퍼소나에 맞는 아이템을 가져와서 넣고 이벤트를 바인딩한다
GentleUtil.quickMenuInit = function(opt){

    const persona = (opt.persona !== undefined)?opt.persona:undefined;
    
    // 폰트조절 . 퍼소나별 퀵메뉴 아이템을 병합한다
    const quickMenuArray = GentleConst.QUICK_MENU_ARRAY.font.concat(GentleConst.QUICK_MENU_ARRAY[persona]);
    
    // 순환하면서 아이템 추가
    quickMenuArray.forEach(element => {
        
        // ListItem
        const $listItem = $("<li>");

        // ICON 
        if(element.icon !== undefined){
            const $figure = $("<figure>");
            $figure.html(element.icon);
            $figure.appendTo($listItem);
        }

        // 제목
        if(element.title !== undefined){
            const $headline = $("<h6>");
            $headline.text(GentleLang.translate(element.title));
            $headline.appendTo($listItem);
        }

        // CSS ID
        if(element.id !== undefined){
            $listItem.attr('id', element.id);
        }

        // CSS CLASS
        if(element.class !== undefined){
            $listItem.addClass(element.class);
        }

        // Event 
        if(element.onClickEvent !== undefined){
            $listItem.on('click', element.onClickEvent);
        }

        // 삽입
        $listItem.appendTo(this.$quickMenuSelector);
    });

    // 퀵메뉴 이벤트 바인드 
    this.$quickMenuButtonSelector.on('click', function(){
        GentleUtil.quickMenuToggle();
    });


    // BG OVERLAY 
    const $quickMenuOverlayHtml = $('<div id = "' + this.quickMenuOverlayID + '" style="display:none"></div>');
    
    // BG OVERLAY 클릭시 퀵메뉴 닫기  
    $quickMenuOverlayHtml.on('click', function(){
        GentleUtil.quickMenuHide();
    });

    // BG OVERLAY 컨텐츠 삽입 
    this.quickMenuOverlaySelector = $quickMenuOverlayHtml.appendTo(GentleAppState.$appRoot);

}

GentleUtil.scrollInteraction = function () {
    const $userBubbles = GentleAppState.$chatConsoleSelector.find(".speech-bubble.user");
    // const $botProfiles = GentleAppState.$chatConsoleSelector.find(".at-profile.bot-profile").not(".loading");
    const $divisions = GentleAppState.$chatConsoleSelector.find(".division")

    // userBubble이 1개 초과일 경우 ( 최초1개는 적용안함 )
    if($userBubbles.length >= 1){

        // userBubble 갯수가 어플리케이션 버블카운터보다 많은 경우
        if($divisions.length > this.divisionCount){

            // Scroll에 필요한 값들을 계산
            const $lastDivision = $divisions.last();    // 마지막 버블

            // 챗콘솔 하단 여백 조정 
            const coversationRootHeight = GentleAppState.$conversationRoot.height(); // 
            // console.log('coversationRootHeight>', coversationRootHeight);
            const chatConsoleHeight = GentleAppState.$chatConsoleSelector.height();
            // console.log('chatConsoleHeight>', chatConsoleHeight);
            const lastUserBubbleTop = $lastDivision.position().top;
            const chatConstoleBottomCalc = coversationRootHeight - (chatConsoleHeight - lastUserBubbleTop);
            this.$chatConsoleBottomSelector.css('height', chatConstoleBottomCalc+'px');
            
            // 마지막 유저 버블 위치로 이동 
            // GentleAppState.$conversationRoot.animate({scrollTop: lastUserBubbleTop}, 700);
            const scrollTop = chatConsoleHeight - coversationRootHeight + 40; // 작을수록 바닥으로...
            // console.log('scrollTop>', scrollTop);
            GentleAppState.$conversationRoot.animate({scrollTop}, 10);

            // 버블 카운터 갱신 
            this.divisionCount = $divisions.length;
        }
    }
}

GentleUtil.fillAuto = function($target){
    let nextVal;
    const prevVal = $target.val();
    const idLength = prevVal.length;
    const lengthCondtion = 8;
    const idPrefix = 'S';
    
    if( prevVal.charAt(0) != idPrefix){
        if(idLength == 7){
            nextVal = idPrefix + prevVal;
        }else if(idLength < 7){
            const lengthDiff = lengthCondtion - idLength;
            nextVal = idPrefix.padEnd(lengthDiff,'0') + prevVal;
        }

        // 변경된 경우 치환 
        if(nextVal !== undefined){
            $target.val(nextVal);
        }
    }
}

// 로딩 애니메이션 생성 
GentleUtil.serviceLoadingShow = function(){
    const $loadingBarHtml = $('<div id="'+this.serviceLodingID+'"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>');
    $loadingBarHtml.appendTo(GentleAppState.$bodyRoot);
}

// 로딩 애니메이션 제거
GentleUtil.serviceLoadingHide = function(){
    $('#' + this.serviceLodingID).remove();
}

// 퀵메뉴 토글 
GentleUtil.quickMenuToggle = function(){
    if( this.$quickMenuSelector.hasClass('show') ){
        this.quickMenuHide();
    }else{
        this.quickMenuShow();
    }
}

// 퀵메뉴 열기 
GentleUtil.quickMenuShow = function(){
    this.$quickMenuSelector.addClass('show');
    this.$quickMenuButtonSelector.addClass('active');
    this.quickMenuOverlaySelector.css('display', 'initial');
}

// 퀵메뉴 닫기 
GentleUtil.quickMenuHide = function(){
    this.$quickMenuSelector.removeClass('show');
    this.$quickMenuButtonSelector.removeClass('active');
    this.$quickMenuSelector.find("#font-handler-button").removeClass('active');
    this.$quickMenuSelector.find(".font-handler").removeClass('show'); 
    this.quickMenuOverlaySelector.css('display', 'none');
}


// 폰트 활성화 
GentleUtil.quickMenuFontToggle = function(){
    if(this.$quickMenuSelector.find("#font-handler-button").hasClass('active')){
        this.$quickMenuSelector.find("#font-handler-button").removeClass('active');
        this.$quickMenuSelector.find(".font-handler").removeClass('show'); 
    }else{
        this.$quickMenuSelector.find("#font-handler-button").addClass('active');
        this.$quickMenuSelector.find(".font-handler").addClass('show'); 
    }
}


// 내부서비스 확인
GentleUtil.serviceListInit = function(opt) {

    const persona = (opt.persona !== undefined)?opt.persona:undefined;
    const serviceArray = GentleConst.SERVICE_ARRAY;
    
    const $selectBoxData = $("<select>");
    var $option = $("<option>");
    $option.text('테스트할 서비스를 선택하세요');
    $option.appendTo($selectBoxData);

    serviceArray.forEach(element => {        
        var $option = $("<option>");
        let speech = GentleAppState.lang.toUpperCase() === GentleLang.lang.KR ? element.speech: element.speech_EN
        speech = speech ? speech : element.title;

        $option.text(element.title);
        // $option.on('click', element.onClickEvent);
        $option.on('click', function(){
            GentleComponentBubble.insertUserBubble({html: speech});
        });

        $option.appendTo($selectBoxData);
    });

    $selectBoxData.on('change', function(){
        $(this).find("option:selected").click();
    });
    
    const $serviceTest = $('<div id="service-test"></div>');
    $serviceTest.append($selectBoxData);
    
    GentleAppState.$appRoot.prepend( $serviceTest );
}


// 슬라이드 팝업 선택자 초기화 
GentleUtil.slidePopupSelectorInit = function(){
    this.$slidePopupSelector = $('#'+this.slidePopupID);
    this.$slidePopupOverlaySelector = $('#'+this.slidePopupOverlayID); 
    this.$slidePopupTitleSelector = $('#'+this.slidePopupID).find("#slide-popup-title");
    this.$slidePopupContentSelector = $('#'+this.slidePopupID).find("#slide-popup-content");
    this.isSlidePopupCreate = (this.$slidePopupSelector.length)?true:false;
}

// 슬라이드 팝업 생성
// @title : 팝업 제목 
// @content : 팝업 컨텐츠 
// @autoHeight : 세로 길이(auto, fix, full)
GentleUtil.createSlidePopup = function (options) {

    const title = options.title;
    const content = options.content;
    const autoHeight = (options.autoHeight === undefined)?"auto":options.autoHeight;
    const bgColor = (options.bgColor === undefined)?"#fff":options.bgColor;
    const headerBgColor = options.headerBgColor;
    
    if(!title || !content){
        throw new Error('title 및 content는 필수 요소입니다');
    }

    // 슬라이드 팝업 최초 호출일경우 관련 인스턴스를 생성합니다 
    if (this.isSlidePopupCreate === undefined) {
        
        // BG OVERLAY 
        const $slidePopupOverlayHtml = $('<div id = "' + this.slidePopupOverlayID + '"></div>');

        // SLIDE POPUP 
        const $slidePopupHtml = $('<div id = "' + this.slidePopupID + '" class="mCustomScrollbar ps">\
        <header>\
            <h3 id="slide-popup-title"></h3>\
            <span id="slide-popup-close"><i class="at-icon at-close"></i></span>\
        </header>\
        <section id="slide-popup-content" class="ps"></section>\
        </div>');

        // overlay 클릭시 팝업닫기 
        $slidePopupOverlayHtml.on('click', function(){
            GentleUtil.removeSlidePopup();
        });

        // 닫기버튼 클릭시 팝업클로즈 
        $slidePopupHtml.find('#slide-popup-close').on('click', function(){
            GentleUtil.removeSlidePopup();
        });

        // 컨텐츠 삽입 
        $slidePopupOverlayHtml.appendTo(GentleAppState.$appRoot);
        $slidePopupHtml.appendTo(GentleAppState.$appRoot); 

    } 

    // 슬라이드 팝업 셀럭터를 갱신합니다
    GentleUtil.slidePopupSelectorInit();


    // overlay활성화 
    this.$slidePopupOverlaySelector.css('display', 'initial');

    
    
    // 컨텐츠 적용 
    const $htmlContent = (typeof content === "object")?content:$(content);
    this.$slidePopupTitleSelector.html(title);
    this.$slidePopupContentSelector.empty().append($htmlContent);


    // 퍼펙트 스크롤 적용 
    this.scrollbar = document.querySelector('#' + this.slidePopupID);
    this.ps = new PerfectScrollbar(this.scrollbar, {
        wheelSpeed: 2,
        // swipeEasing: true,
        suppressScrollX: true,
        wheelPropagation: true,
    });

    // 세로값 조정 
    if(autoHeight == 'fix'){
        this.$slidePopupSelector.addClass('fix');
    }else if(autoHeight == 'full'){
        this.$slidePopupSelector.addClass('full');
    }else{
        this.$slidePopupSelector.removeClass('fix').removeClass('full');
    }

    // boxShadow 및 show적용
    if( GentleAppState.$conversationRoot.height() > this.$slidePopupSelector.height() ){
        this.$slidePopupSelector.addClass('no-scroll').addClass('show-bottom');
        //this.ps.destroy();
    }else{
        this.$slidePopupSelector.removeClass('no-scroll');
        if(autoHeight == 'full'){
             this.$slidePopupSelector.addClass('show-bottom');
        }else{
            this.$slidePopupSelector.addClass('show-top');
        } 
    }

    // 팝업활성화 및 BG-COLOR설정
    this.$slidePopupSelector.css('background-color',bgColor);

    if(headerBgColor !== undefined){
        this.$slidePopupSelector.find("header").css('background-color',headerBgColor);
    }
    
    this.$slidePopupSelector.removeClass('hide');


    // fixed 요소 
    const $fixedBottomLayer = this.$slidePopupContentSelector.find("#fixed-bottom-layer");
    if( $fixedBottomLayer.length > 0 ){        
        $fixedBottomLayer.parent().css('margin-bottom', $fixedBottomLayer.outerHeight() + 'px');
    }

}


// 슬라이드팝업 제거
GentleUtil.removeSlidePopup = function () {
    if(this.$slidePopupOverlaySelector){
        this.$slidePopupOverlaySelector.css('display', 'none');
        this.$slidePopupSelector.removeClass('show-top').removeClass('show-bottom').addClass('hide');
    }
}

// 슬라이드팝업 스크롤 하단으로 이동
GentleUtil.scrollDownSlidePopup = function(){

    let slidePopupScrollTop = this.$slidePopupContentSelector.height();
    if(this.$slidePopupSelector.find(".first-item").length > 0){
        slidePopupScrollTop = this.$slidePopupSelector.find(".first-item").last().position().top;
    }

    this.$slidePopupSelector.animate({'scrollTop':slidePopupScrollTop}, 700);
}

// 토스트팝업 생성
// @msg : 토스트팝업 메시지 (text|html)
// Author : KimTaeOh
GentleUtil.createToastMessage = function (msg) {
    // 토스트 인스턴스가 없으면 생성
    // 토스트 인스턴스가 있으면 텍스트만 변경 
    let $toastMessageSelector = $('#'+this.toastMessageID);

    if ($toastMessageSelector.length == 0) {
        const $toastHtml = $('<div id="' + this.toastMessageID + '" class="show">' + msg + '</div>');
        $toastMessageSelector = $toastHtml.appendTo(GentleAppState.$appRoot);
    } else {
        $toastMessageSelector.text(msg).removeClass('hidden').addClass('show');
    }

    // 타이머 이후 제거
    clearTimeout(this.toastMessageRemoveTimer);
    this.toastMessageRemoveTimer = setTimeout(function () {     
        console.log('clear', $toastMessageSelector);
        $toastMessageSelector.removeClass('show').addClass('hidden');
        console.log('clear', $toastMessageSelector);
    }, this.toastMessageRemoveTime);
}

// 업데이트토스트팝업 생성
// @msg : 토스트팝업 메시지 (text|html)
// Author : YuJaeWu
GentleUtil.createUpdateToastMessage = function (msg) {
    // 토스트 인스턴스가 없으면 생성
    // 토스트 인스턴스가 있으면 텍스트만 변경 
    let $toastMessageSelector = $('#'+this.toastUpdateMessageID);

    if ($toastMessageSelector.length == 0) {
        const $toastHtml = $('<div id="' + this.toastUpdateMessageID + '" class="show">' + msg + '</div>');
        $toastMessageSelector = $toastHtml.appendTo(GentleAppState.$appRoot);
    } else {
        $toastMessageSelector.text(msg).removeClass('hidden').addClass('show');
    }

    // 타이머 이후 제거
    clearTimeout(this.toastMessageRemoveTimer);
    this.toastMessageRemoveTimer = setTimeout(function () {     
        $toastMessageSelector.removeClass('show').addClass('hidden');
    }, this.toastUpdateMessageRemoveTime);
}
// 클립보드 복사 
// @text : 복사할 전문 
// @callback : 콜백함수 
// Author : KimTaeOh
GentleUtil.copyTextToClipboard = function(text, callback) {
    if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text, callback);
        return false;
    }
    
    navigator.clipboard.writeText(text).then(function (cb=callback) {
        const result = true;
        cb(result);
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
        const result = false;
        cb(result);
    });
}

// 클릭보드가 객체를 이용하지 못할시 FallbackFunction 
// @text : 복사할 전문 
// @callback : 콜백함수 
// Author : KimTaeOh
GentleUtil.fallbackCopyTextToClipboard = function(text, callback) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "-2000";
    textArea.style.left = "-2000";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        const result = true;
        callback(result);
        //return true;
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
        const result = false;
        callback(result);
        //return false;
    } 

    document.body.removeChild(textArea);
}


// 쿠키 생성하기
// @cname : 복사할 전문 
// @cvalue : 콜백함수 
// @exdays : 만료일 
// Author : KimTaeOh
GentleUtil.setCookie = function(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;SameSite=None; Secure";
}

// 쿠키 가져오기 
// @cname : 쿠키이름
// Author : KimTaeOh
GentleUtil.getCookie = function(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

GentleUtil.getQueryStringObject = function () {     
    var params = {};  
    
    window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, 
    	function(str, key, value) { 
        	params[key] = value; 
        }
    );     
    
    return params; 
}

GentleUtil.pad = function(n, width) {
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;  
}

GentleUtil.yyyymmddhhmmss = function(){
    var date = new Date();
    var year = date.getFullYear().toString();

    var month = date.getMonth() + 1;
    month = month < 10 ? '0' + month.toString() : month.toString();

    var day = date.getDate();
    day = day < 10 ? '0' + day.toString() : day.toString();

    var hour = date.getHours();
    hour = hour < 10 ? '0' + hour.toString() : hour.toString();

    var minites = date.getMinutes();
    minites = minites < 10 ? '0' + minites.toString() : minites.toString();

    var seconds = date.getSeconds();
    seconds = seconds < 10 ? '0' + seconds.toString() : seconds.toString();

    return year + month + day + hour + minites + seconds;
}

// 금일 yyyy.mm.dd
GentleUtil.dateStringSeminar = function(date){
    
    const dt = new Date(date);

    const yyyy = dt.getFullYear();
    const mm =  GentleUtil.pad(dt.getMonth() + 1, 2);
    const dd = GentleUtil.pad(dt.getDate(), 2);
    let hh = dt.getHours()
    if(dt.getHours() < 10){
        hh = `0${dt.getHours()}`
    }
    let mi = dt.getMinutes()
    if(dt.getMinutes()===0){
        mi = "00"
    }
    return `${yyyy}.${mm}.${dd} ${hh}:${mi}`;
}
GentleUtil.dateString = function(date){
    
    const dt = new Date(date);

    const yyyy = dt.getFullYear();
    const mm =  GentleUtil.pad(dt.getMonth() + 1, 2);
    const dd = GentleUtil.pad(dt.getDate(), 2);
   
    return `${yyyy}.${mm}.${dd}`;
}
GentleUtil.dateStringSchedule = function(date){
    
    const dt = new Date(date);

    const yyyy = dt.getFullYear();
    const mm =  GentleUtil.pad(dt.getMonth() + 1, 2);
    const dd = GentleUtil.pad(dt.getDate(), 2);
   
    return `${yyyy}-${mm}-${dd}`;
}
GentleUtil.comma = function(num){
    var len, point, str;

    num = num + "";
    point = num.length % 3 ;
    len = num.length;

    str = num.substring(0, point);
    while (point < len) {
        if (str != "") str += ",";
        str += num.substring(point, point + 3);
        point += 3;
    }
    return str;
}

GentleUtil.timeToString = function(dt){
    var month = dt.getMonth()+1;
    var day = dt.getDate();
    var year = dt.getFullYear();
    return year + "-"+GentleUtil.pad(month, 2)+"-"+GentleUtil.pad(day, 2);
}

GentleUtil.todayString = function(){
    var dt = new Date();

    return GentleUtil.timeToString(dt);
}

GentleUtil.compareImage = function(left, right){
    if(Number(left) > Number(right)) return "performance_lt";
    if(Number(left) < Number(right)) return "performance_rt";
    return "performance_eq";
}

GentleUtil.timeStamp = function(){
    var stamp = Object.create( GentleComponentTimeStamp );
    stamp.createComponent({});
    stamp.insert();
}

GentleUtil.timeSplit = function(time){
    let temp = time.split('T')[0];  // yyyy-mm-dd
    let arr = temp.split('-');
    const obj = {
        yyyy: arr[0],
        mm: arr[1],
        dd: arr[2],
    }
    return obj;
}

GentleUtil.orderStatusClass = function(OrderStatusType){
    let className = '';
    // OrderStatusType : 주문상태 / 1(주문완료), 2(결제완료), 11(주문취소), 12(결제취소), 13(미결제마감), 101(배송준비중), 102(배송중), 103(배송완료)
    switch (`${OrderStatusType}`) {
        case 'ORD_PAY_FINISH':
            className = 'at-order-complete';
            break;
        case '결제완료':   // 결제완료
            className = 'at-pay-complete';
            break;
        case 'ORD_PAY_CANCEL':  // 주문취소
            className = 'at-order-cancel';
            break;
        case '결제취소': // 결제 취소
            className = 'at-pay-cancel';
            break;
        case 'ORD_PAY_DEADLINE': // 미결제마감
            className = 'at-nopay-complete';
            break;
        case '배송준비중': // 배송준비중
            className = 'at-delivery-ready';
            break;
        case 'ORD_SHIP_FINISH': // 배송중
            className = 'at-transit';
            break;
        case 'ORD_DELI_FINISH': // 배송완료
            className = 'at-delivered';
            break;    
        default:
            break;
    }
    return className;
}

GentleUtil.maskingNo = function(CustNo){
    const len = CustNo.length;
    CustNo = CustNo.split('');

    if(len>4)
        CustNo[3] = '*';

    if(len>5)
        CustNo[4] = '*';

    if(len>6)
        CustNo[5] = '*';

    CustNo = CustNo.join();
    CustNo = CustNo.replace(/,/g, '');

    return CustNo;
}

GentleUtil.maskingName = function(CustName){
    let checkEng = /[a-zA-Z]/;
    const isEng = checkEng.test(CustName);
    if(isEng){
        // 앞자리 3자리를 제외하고 모두 마스킹 적용
        CustName = CustName.split('');
        for (let index = 3; index < CustName.length; index++) {
            CustName[index] = '*';                            
        }
    }else{
        // 2글자인 경우 2번째 자리 적용
        // 3글자인 경우 2번째 자리 적용
        // 4자 이상~7자 이하인 경우 2,3번째 자리 적용
        CustName = CustName.split('');
        if(CustName.length ==2 || CustName.length == 3){
            CustName[1] = '*';
        }else if(CustName.length > 3){
            CustName[1] = '*';
            CustName[2] = '*';
        }
    }
    CustName = CustName.join();
    CustName = CustName.replace(/,/g, '');
    return CustName;
}

GentleUtil.htmlHello = function(){
    const {custName, MaxMasterShip} = GentleAppState;

    // 직급자 아닐경우 : 안녕하세요, $user.name$님!
    let html = GentleLang.translateService(language.product, language.product.type.Hello, {name: custName});

    // 직급자의 경우 명목직급을 넣어 주세요:  Ex) 안녕하세요, 김토미 샤론로즈마스터님!
    if(MaxMasterShip){
        const level = GentleLang.mastershipType(MaxMasterShip);
        html = GentleLang.translateService(language.product, language.product.type.Hello2, {name: custName, level});
    }

    return html;
}

GentleUtil.levelPoint = function(level){
    /**
    소실적 맞춤상품 공식 

    6-1. 조건   
    *본인등급 : 회원이상 
    *소실적 기준 
    - 회원. 에이전트 : 30만 
    - 특약점 : 70만 
    - 대리점 : 150만 
    - 총판( 1 - 4급 ) : 240만 

    6-2. 공식 
    (소실적기준 - 소실적) + 50,000PV 
    +50,000PV는 API에서 계산하기 때문에 젠틀파이는 ( 소실적기준 - 소실적 ) 으로 요청 
        */

    let point = 0;
    switch (Number(level)) {
        case 0: // 회원
        case 1: // 에이전트
            point = 300000;
        break;
        case 2: // 특약점
            point = 700000;
        break;
        case 3: // 특약점
            point = 1500000;
        break;
        case 4: // 특약점
            point = 2400000;
        break;                            
        default:
            break;
    }
    return point;
}

const sso = function(ssoRequestUrl, redirectUrl, ssoToken){        
    const Url = encodeURIComponent(redirectUrl);
    const Token = encodeURIComponent(ssoToken);
    const ssoUrl = ssoRequestUrl.GentleFormat({Token, Url});
    // console.log('ssoUrl', ssoUrl);

    window.open(ssoUrl);
}

GentleUtil.updateSSOToken = function(){
    window.chatbotSSOToken = '';
    
    const onSuccess = function(data){
        switch(data.Status){
        case 1:
            const ssoToken = data.Data;
            window.chatbotSSOToken = ssoToken;
            // sso(ssoRequestUrl, redirectUrl, ssoToken);
            break;
        default:
            throw 'SSO 토큰이 발급되지 않았습니다';
            break;
        }
    };

    // SSO 토큰 발급 실패 
    const onFailed = function(data){
        console.log('SSOFailed');
    }

    // SSO 토큰 요청
    const proxy = Object.create(GentleProxy);
    const param = {};
    proxy.request("sso", param, onSuccess, onFailed );
}

// sso를 적용한 주소로 리다이렉트 
GentleUtil.ssoOpen = function (url){
    
    // 개발/운영서버 상태(dev|prd)
    const serverProfile = GentleAppState.serverProfile; 

    // 개발/운영 상태 Const 객체를 참조하기 위한 Property
    const constDeviceProperty = (GentleAppState.isPc)?'pcDomain':'mobileDomain'

    // 서버상태에 따라 사용할 도메인 결정 
    const atomyDomain = GentleConst.ATOMY_URL[serverProfile][constDeviceProperty];

    // 서버상태에 따른 도메인을 치환한 SSO URL
    const ssoRequestUrl = GentleConst.SSO_URL[constDeviceProperty].GentleFormat({atomyDomain});

    // 서버상태에 따른 도메인을 치환한 Redict URL
    const redirectUrl = url.GentleFormat({atomyDomain});

    const ssoToken = window.chatbotSSOToken;
    console.log(url)
    const browserInfo = window.navigator.userAgent;
    const isHybrid = browserInfo.includes('MARKET_GOOGLE') || browserInfo.includes('MARKET_APPSTORE');
    if(ssoToken){
        if(url === 'https://shop.atomy.com/kr/cart'){
            isHybrid ? window.open(redirectUrl,'_self') 
            : (GentleAppState.isPc)? window.open(redirectUrl) 
                : window.location.href = redirectUrl;
        }else {
            sso(ssoRequestUrl, redirectUrl, ssoToken);
        }
    }
    else{
        isHybrid ? window.open(redirectUrl,'_self')
        : (GentleAppState.isPc)? window.open(redirectUrl) 
            : window.location.href = redirectUrl;
    }
}

export default GentleUtil;